import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext';
export const useInternalPropertyValue = () => {
  const {
    value
  } = useContext(PropertyContext);
  return value;
};